// extracted by css-extract-rspack-plugin
export default {"pagination":"FN_I3DyA8yEskyHH","hud":"YadVOt_RexER08lA"};